import React from 'react';
import { withStyles,
  FormControl,
  TextField,
  Typography,
  Switch,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle } from '@material-ui/core';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 290,
  },
  flex: {
    display: 'flex',
  },
  typographySwitch: {
    paddingTop: theme.spacing.unit * 1.7,
    marginLeft: theme.spacing.unit,
    color: theme.palette.text.secondary,
    fontSize: 13,
  },
});
class FormDialogFaixaEtaria extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      ...this.props.faixa,
      errorMessageIdadeInicio: '',
      errorMessageIdadeFim: '',
    };
  }
  handleClickSave = async () => {
    const faixa = {
      seqIdade: this.state.seqIdade === undefined ? 0 : this.state.seqIdade,
      idadeInicio: Number(this.state.idadeInicio),
      idadeFim: Number(this.state.idadeFim),
      indAtivo: this.state.indAtivo === null || this.state.indAtivo === undefined ? 'S' : this.state.indAtivo,
    };
    await this.props.handleSave(faixa);
  }
  handleChangeTextField = event => {
    var valorNovo = '';
    if (event.target.name === 'idadeInicio') {
      valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 3);
      this.setState({ [event.target.name]: valorNovo, errorMessageIdadeInicio: '' });
    }
    if (event.target.name === 'idadeFim') {
      valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 3);
      this.setState({ [event.target.name]: valorNovo, errorMessageIdadeFim: '' });
    }
  };
  handleBlurIdadeInicio = event => {
    if (this.state.idadeInicio === '' || this.state.idadeInicio === null || this.state.idadeInicio === undefined) {
      this.setState({errorMessageIdadeInicio: 'Favor preencher a idade inicial'});
    }
    if (this.state.idadeFim !== '' && this.state.idadeFim !== null && this.state.idadeFim !== undefined &&
       this.state.idadeInicio !== '' && this.state.idadeInicio !== null && this.state.idadeInicio !== undefined &&
     Number(this.state.idadeFim) <= Number(this.state.idadeInicio)) {
      this.setState({errorMessageIdadeInicio: 'Idade início maior que a idade final'});
    } else {
      this.setState({errorMessageIdadeInicio: '', errorMessageIdadeFim: ''});
    }
  }
  handleBlurIdadeFim = event => {
    if (this.state.idadeFim === '' || this.state.idadeFim === null || this.state.idadeFim === undefined) {
      this.setState({errorMessageIdadeFim: 'Favor preencher a idade final'});
    }
    if (this.state.idadeFim !== '' && this.state.idadeFim !== null && this.state.idadeFim !== undefined &&
       this.state.idadeInicio !== '' && this.state.idadeInicio !== null && this.state.idadeInicio !== undefined &&
     Number(this.state.idadeFim) <= Number(this.state.idadeInicio)) {
      this.setState({errorMessageIdadeFim: 'Idade fim menor que a início'});
    } else {
      this.setState({errorMessageIdadeInicio: '', errorMessageIdadeFim: ''});
    }
  }
  handleChangeIndAtivo = event => {
    this.setState({ indAtivo: event.target.checked ? 'S' : 'N' });
  };
  isSalvarDisabled = () => {
    return (this.state.errorMessageIdadeInicio !== '' ||
    this.state.idadeInicio === undefined ||
    this.state.idadeInicio === '' ||
    this.state.idadeInicio === 0) ||

    (this.state.errorMessageIdadeFim !== '' ||
    this.state.idadeFim === undefined ||
    this.state.idadeFim === '' ||
    this.state.idadeFim === 0);
  }
  render () {
    const { classes, open, handleClose, titulo } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='xs'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>{titulo}</DialogTitle>
          <DialogContent>
            <FormControl className={classes.formControl}>
              <TextField
                value={this.state.idadeInicio === null ? '0' : this.state.idadeInicio}
                margin='dense'
                id='idadeInicio'
                name='idadeInicio'
                error={this.state.errorMessageIdadeInicio !== ''}
                label={this.state.errorMessageIdadeInicio !== '' ? this.state.errorMessageIdadeInicio : 'Idade Início'}
                fullWidth
                onChange={this.handleChangeTextField}
                onBlur={this.handleBlurIdadeInicio}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                value={this.state.idadeFim === null ? '0' : this.state.idadeFim}
                margin='dense'
                id='idadeFim'
                name='idadeFim'
                error={this.state.errorMessageIdadeFim !== ''}
                label={this.state.errorMessageIdadeFim !== '' ? this.state.errorMessageIdadeFim : 'Idade Final'}
                fullWidth
                onChange={this.handleChangeTextField}
                onBlur={this.handleBlurIdadeFim}
              />
            </FormControl>
            <FormControl>
              <div className={classes.flex}>
                <Typography className={classes.typographySwitch}>
                  Faixa de Idade Ativa?
                </Typography>
                <Switch
                  disabled={!this.props.isEditavel}
                  checked={this.state.indAtivo === undefined ? true : this.state.indAtivo === 'S'}
                  onChange={this.handleChangeIndAtivo}
                  color='primary'
                />
              </div>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled()}
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogFaixaEtaria);
